import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as actions from './actions';

const initialState = {
  error: {},
  isLoading: false,
  list: [],
  nextPage: null,
  success: {},
};

const setFetchBookingsListRequest = (state) => update(state, {
  error: { $set: {} },
  isLoading: { $set: true },
  nextPage: { $set: null },
  success: { $set: {} },
});

const setFetchBookingsListSuccess = (state, action) => update(state, {
  isLoading: { $set: false },
  list: { $set: action.payload.reset ? [] : state.list.concat(action.payload.list) },
  nextPage: { $set: action.payload.nextPage },
});

const setFetchBookingsListFailure = (state, action) => update(state, {
  error: { $set: action.payload.error },
  isLoading: { $set: false },
  nextPage: { $set: null },
});

export default handleActions({
  [actions.FETCH_BOOKINGS_LIST_REQUEST]: setFetchBookingsListRequest,
  [actions.FETCH_BOOKINGS_LIST_SUCCESS]: setFetchBookingsListSuccess,
  [actions.FETCH_BOOKINGS_LIST_FAILURE]: setFetchBookingsListFailure,
}, initialState);
